module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// ./~/@cerebral/react/index.js
// module id = 218
// module chunks = 0